// @ts-nocheck
// Monitor / Whisper / Barge trigger group for one agent row. Disabled with a
// reason in the tooltip whenever the agent has no answered call, another
// snoop is already running, or the ACL denies it.
import React from 'react';
import { Headphones, Radio, Volume2 } from 'lucide-react';
import { SNOOP_MODES } from './useSnoop';
import { TONE } from './teamUi';

const ICONS = { monitor: Headphones, whisper: Volume2, barge: Radio };

export default function SnoopButtons({ row, snoop, allowed, compact = false }) {
  const size = compact ? 'h-6 w-6' : 'h-7 w-7';
  return (
    <span className="inline-flex gap-1">
      {SNOOP_MODES.map(({ mode, label, tone }) => {
        const Icon = ICONS[mode];
        const isActive = snoop.isActive(row.agent?.id, mode);
        const enabled = allowed && (isActive || snoop.canUse(row, mode));
        const title = !allowed
          ? 'ACL permission missing for Agents'
          : isActive
            ? `Stop ${label}`
            : !snoop.hasListener
              ? 'Connect your own phone (WebRTC/SIP) via the Dialer first to listen in'
              : !row.snoop.answered
                ? `${label} — agent is not on a call`
                : !row.snoop.callId
                  ? 'Call connecting — please wait'
                  : snoop.session
                    ? 'Another snoop is in progress'
                    : label;
        return (
          <button
            key={mode}
            type="button"
            title={title}
            aria-label={title}
            disabled={!enabled}
            onClick={() => (isActive ? snoop.stop() : snoop.start(mode, row))}
            className={`grid ${size} place-items-center rounded-md transition-colors disabled:cursor-not-allowed disabled:bg-muted/50 disabled:text-muted-foreground/50 ${isActive ? `${TONE[tone].bg} text-white` : `${TONE[tone].soft} ${TONE[tone].text} hover:brightness-95`
              }`}
          >
            <Icon size={compact ? 11 : 12} />
          </button>
        );
      })}
    </span>
  );
}
